import ConnectVercel from 'pages/connect/ConnectVercel'

export default [
    {
        path: '/connect/vercel',
        name: 'ConnectVercel',
        component: ConnectVercel,
        meta: {
            requiresAuth: true,
            title: 'Connect Vercel',
            minimal: true,
        },
        beforeEnter: (to, from, next) => {

            if (localStorage?.getItem('__IS_FOR_VERCEL__') !== 'true') {
                return next('/')
            }

            next() // Proceed to dashboard
        },
    },
    {
        path: '/connect',
        redirect: '/connect/vercel',
    }
]
